import { COLORS } from '@/constants';
import { Button } from '@mui/material';
import styled from 'styled-components';

export const Wrapper = styled.div`
  width: 100%;
`;

export const LineWrapper = styled('div')`
  display: flex;
  justify-content: space-between;
  gap: 15px;
  margin-bottom: 12px;
`;

export const LineWrapperMultiple = styled('div')`
  display: grid;
  grid-template-columns: 2fr 1fr 1fr;
  gap: 15px;
  margin-bottom: 12px;
`;

export const LineWrapperDouble = styled('div')`
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 15px;
  margin-bottom: 12px;
`;

export const CheckboxLineWrapper = styled.div`
  display: grid;
  grid-template-columns: 1fr 1fr;
  margin-bottom: 10px;

  @media (max-width: 625px) {
    grid-template-columns: 1fr 1fr;
  }

  @media (max-width: 410px) {
    grid-template-columns: 1fr;
  }
`;

export const CheckboxInner = styled.div`
  display: flex;
  align-items: center;
  flex-direction: column;
`;

export const StyledWAButton = styled(Button)`
  && {
    height: 44px;
    width: 100%;
    background-color: #5bbb5b;
    color: ${COLORS['additional/50']};
    transition: background-color 0.2s ease;

    &:hover {
      background-color: #326b32ff;
    }
  }
`;
